import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import {
  TimesheetEntry,
  TimesheetState,
  TimesheetEntryType,
} from '@sdk/timesheets/types/TimesheetEntry';
import getPendingTimesheetState from '@sdk/timesheets/helpers/getPendingTimesheetState';

import ManagerApprovedBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/ManagerApprovedBanner';
import ManagerViewPendingManagerApprovalBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/manager/ManagerViewPendingManagerApprovalBanner';
import ManagerViewPendingEmployeeConsentBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/manager/ManagerViewPendingEmployeeConsentBanner';
import ManagerViewEmployeeDeniedBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/manager/ManagerViewEmployeeDeniedBanner';
import ManagerViewEmployeeConsentGivenBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/manager/ManagerViewEmployeeConsentGivenBanner';
import ManagerViewEmployeeDeniedNewEntriesBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/manager/ManagerViewEmployeeDeniedNewEntriesBanner';

type Props = {
  timesheetStatus: TimesheetStatus;
  timesheetEntries: TimesheetEntry[];
  employeeName: string;
};
const TimesheetViewModalBannerManager = ({
  timesheetStatus,
  timesheetEntries,
  employeeName,
}: Props) => {
  if (timesheetStatus === TimesheetStatus.approved) {
    return <ManagerApprovedBanner />;
  }

  if (timesheetStatus === TimesheetStatus.pending) {
    const { state, consentDenyReason } = getPendingTimesheetState(timesheetEntries);

    if (state === TimesheetState.consentGiven) {
      return <ManagerViewEmployeeConsentGivenBanner employeeName={employeeName} />;
    }

    if (state === TimesheetState.consentDenied) {
      const hasTimeClockEntries = timesheetEntries.some(
        ({ type }) => type === TimesheetEntryType.clockIn
      );

      return hasTimeClockEntries ? (
        <ManagerViewEmployeeDeniedBanner
          employeeName={employeeName}
          consentDenyReason={consentDenyReason}
        />
      ) : (
        <ManagerViewEmployeeDeniedNewEntriesBanner
          employeeName={employeeName}
          consentDenyReason={consentDenyReason}
        />
      );
    }

    return <ManagerViewPendingManagerApprovalBanner />;
  }

  if (timesheetStatus === TimesheetStatus.pendingConsent) {
    return <ManagerViewPendingEmployeeConsentBanner />;
  }

  return null;
};

export default TimesheetViewModalBannerManager;
